<template>
  <NuxtLayout>
    <PoliciesThePrivacyPolicy />
    <PoliciesCaliforniaNotice />
    <PoliciesNevadaNotice />
    <PoliciesVirginiaNotice />
    <PoliciesColoradoNotice />
    <PoliciesConnecticutNotice />
    <PoliciesUtahNotice />
    <PoliciesDoNotTrackNotice />
  </NuxtLayout>
</template>

<script setup lang="ts">
/**
 * Privacy Policy
 * This page is responsible for rendering the privacy policy.
 */

// Set the page meta data
definePageMeta({
  showNotificationBar: false,
  showFabModal: false,
})

// Set the page title
useHead({
  title: 'Privacy Policy',
})
</script>
